module.exports = __webpack_public_path__ + "img/vertical_7_6_7016.1cd46981.png";